import React from 'react';

const Settings = React.lazy(() => import('./SettingsPage' /* webpackChunkName: "Settings" */));
export default function SettingsInitializer() {
    return <Settings />;
}
